module.exports = __webpack_public_path__ + "img/logo.e066cfd5.svg";